module.exports = __webpack_public_path__ + "static/media/concert-1.9e1b7f3f.png";